import { memo } from "react";
import styled from "styled-components/macro";
import Coupon from "..";

const LargeCoupon = styled(Coupon)`
  margin-top: 24px;

  &::first-of-type {
    margin-top: 0;
  }
`;

export default memo(LargeCoupon);
